import apiRequest from '@/js/helpers/apiRequest';
import { buildErrorCollection } from '@/js/utils/processingOpenApi';
import { ERROR_CALL_ORDER, ERROR_CAPTCHA } from '@/js/utils/constants/constUser';
import { SMS_RESENDING_TIMEOUT } from '@/js/helpers/globalConst';

/**
 * Новый эндпоинт - Отправляет проверочный код по СМС для подтверждения номера телефона
 * @param {object} payload
 * @param {string} [payload.phone]
 * @param {string} [payload.captchaToken]
 * @param {string} [payload.captchaAction]
 * @param {('rv2' | 'rv3')} [payload.captchaVersion]
 * @return {Promise<number>}
 */
export default function sendSmsConfirmNew(payload) {
  return new Promise((resolve, reject) => {
    if (!payload.phone) {
      return reject(ERROR_CALL_ORDER.notStringPhone);
    }
    if (typeof payload.phone !== 'string') {
      return reject(ERROR_CALL_ORDER.emptyPhone);
    }
    if (!payload.captchaToken) {
      return reject(ERROR_CAPTCHA.emptyCaptchaToken);
    }
    if (typeof payload.captchaToken !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaToken);
    }
    if (!payload.captchaAction) {
      return reject(ERROR_CAPTCHA.emptyCaptchaAction);
    }
    if (typeof payload.captchaAction !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaAction);
    }
    if (!payload.captchaVersion) {
      return reject(ERROR_CAPTCHA.emptyCaptchaVersion);
    }
    if (typeof payload.captchaVersion !== 'string') {
      return reject(ERROR_CAPTCHA.notStringCaptchaVersion);
    }
    return apiRequest.post('/phones/', payload)
      .then((dataRes) => {
        if (dataRes.success) {
          // eslint-disable-next-line camelcase
          if (dataRes?.token_expired_at) return resolve(dataRes.token_expired_at * 1000);
          return resolve(SMS_RESENDING_TIMEOUT);
        }

        throw new Error();
      })
      .catch((e) => {
        if (e.data) {
          const errors = buildErrorCollection(e.data);
          const [firstError] = errors;
          return reject(firstError);
        }
        return reject(e);
      });
  });
}
